import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import { CardActionArea } from '../base/Card'
import Typography from '../base/Typography'
import PackageJobVisitLink, {
  PackageJobVisitProps
} from '../button/PackageJobVisitLink'
import Icon from '../icons/Icons'
import CardPopover, { CardPopoverProps } from '../molecules/CardPopover'
import Tags, { TagInterface } from '../tags/Tags'

export interface Visit {
  id: string
  packageCode: string
  cleaner: string
  client: string
  address: string
  date: string
  time: string
}

export type VisitAssignmentCardProps = {
  visit: Visit
  tags: TagInterface[]
  onClick(): void
  data: CardPopoverProps['data']
} & PackageJobVisitProps

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: theme.spacing(30),
      maxWidth: '100%',
      borderRadius: 4
    },
    cardContent: {
      paddingBottom: 0
    },
    cardContentHeader: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2)
    },
    cardContentCleaner: {
      display: 'grid',
      gridTemplateColumns: 'min-content 1fr',
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(2),
      gridColumnGap: theme.spacing(1)
    },
    cardContentBody: {
      display: 'grid',
      gridTemplateColumns: 'min-content 1fr',
      gridColumnGap: theme.spacing(3)
    },
    cardContentFooter: {
      display: 'grid',
      gridRowGap: theme.spacing(0.5)
    },
    cardAction: {
      paddingLeft: theme.spacing(2),
      justifyContent: 'space-between'
    },
    textColor: {
      color: theme.palette.grey[800]
    }
  })
)

const VisitAssignmentCard: React.FC<VisitAssignmentCardProps> = (props) => {
  const { visit, tags, data, onClick, packageJobVisit } = props
  const classes = useStyles()
  const menuOpenPopover = (event: { stopPropagation: () => void }): void => {
    event.stopPropagation()
  }
  return (
    <CardActionArea onClick={onClick} classes={{ root: classes.card }}>
      <Card elevation={1}>
        <CardContent className={classes.cardContent}>
          <Box className={classes.cardContentHeader}>
            <Typography variant="subtitle2"> Visit Details </Typography>
            <Box display="flex" alignItems="center">
              <PackageJobVisitLink {...packageJobVisit} visitId={visit?.id} />
              <Typography variant="caption">
                {` | ${visit.packageCode}`}
              </Typography>
            </Box>
          </Box>
          {visit.cleaner && (
            <Box className={classes.cardContentCleaner}>
              <Icon iconName="CleaningIcon" size="small" />
              <Typography variant="overline" children={visit.cleaner} />
            </Box>
          )}
          <Box className={classes.cardContentBody}>
            <Typography className={classes.textColor} variant="caption">
              Client:
            </Typography>
            <Typography variant="caption">{visit.client}</Typography>

            <Typography className={classes.textColor} variant="caption">
              Address:
            </Typography>

            <Box minHeight="40px">
              <Typography variant="caption">{visit.address}</Typography>
            </Box>
            <Typography className={classes.textColor} variant="caption">
              Date:
            </Typography>
            <Typography variant="caption"> {visit.date} </Typography>
            <Typography className={classes.textColor} variant="caption">
              Time:
            </Typography>
            <Typography variant="caption">{visit.time}</Typography>
          </Box>
        </CardContent>
        <CardActions className={classes.cardAction}>
          <Box display="flex" gridGap={4}>
            {tags.map((tag, index) => {
              return (
                <Box key={`tag-${index}`}>
                  <Tags
                    customVariant={tag ? tag.variant : 'homeCleaning'}
                    label={tag.label}
                    sizes="xs"
                  />
                </Box>
              )
            })}
          </Box>
          <Box onClick={menuOpenPopover}>
            <CardPopover data={data} />
          </Box>
        </CardActions>
      </Card>
    </CardActionArea>
  )
}

export default VisitAssignmentCard
